module.exports = __webpack_public_path__ + "img/低通1000.653afabc.png";